import { Directive, Input, EventEmitter, Output, HostListener } from '@angular/core';
import { UntypedFormGroup, AbstractControl, UntypedFormArray, UntypedFormControl } from '@angular/forms';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[formGroup]',
    standalone: false
})
export class FormValidateDirective {
	@Input()
	formGroup: UntypedFormGroup;

	@Output()
	validSubmit = new EventEmitter<UntypedFormGroup>();

	@HostListener('submit')
	onSubmit() {
		if (this.formGroup.valid) {
			this.validSubmit.emit(this.formGroup.getRawValue());
			return;
		}
		this.markAsTouchedAndDirty(this.formGroup);
	}

	markAsTouchedAndDirty(control: AbstractControl) {
		if (control instanceof UntypedFormGroup) {
			Object.keys(control.controls).forEach(key => this.markAsTouchedAndDirty(control.controls[key]));
		} else if (control instanceof UntypedFormArray) {
			control.controls.forEach(c => this.markAsTouchedAndDirty(c));
		} else if (control instanceof UntypedFormControl && control.enabled) {
			control.markAsDirty();
			control.markAsTouched();
			control.updateValueAndValidity();
		}
	}
}


